import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './FileWeblinksDlg.html?raw';

import { HTWebfileLink, VtFile, WebfileLink, WeblinkEditorReponse, WebPlacement } from "./WeblinksEditorTypes";

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import _uiFrameMixin from '../../moreCore/UI/Container/uiFrame';
import lang from 'dojo/_base/lang';
import StaticTable from '../../moreCore/UI/StaticTable/StaticTable';
import EntityStore from '../../moreCore/Tools/EntityStore';
import Edit from '../../moreCore/UI/Edit/Edit';
import FloatingMenu from '../../moreCore/UI/Floating/Menu';

class FileWeblinksDlg extends compose(_WidgetBaseSP, _uiFrameMixin) {
    templateString: any = template;

    private file: VtFile;
    private inputFilename: MdsLax<InstanceType<typeof Edit>>;
    private inputFileCategory: MdsLax<InstanceType<typeof Edit>>;

    private webPlacements: Array<WebPlacement>;

    private tableContainer: HTMLElement;

    private rowConfig: StaticTable.RowConfig = {
        attributes: [
            "description",
            "ref_main_ht_webfile_link_category.ref_webfile_link_category.description",
            "ref_web_placement.description",
        ],
        headings: [
            (this as any).translate("General_Label_Description"),
            (this as any).translate("General_Label_MainCategory"),
            (this as any).translate("General_Label_WebPlacement"),
        ],
        colNamesInternal: [
            "description",
            "ref_main_ht_webfile_link_category.ref_webfile_link_category.description",
            "ref_web_placement.description",
        ]
    }

    private tableLayout: StaticTable.Layout = {
        label: "weblinksTable",
        name: "weblinksTable",
        rows: [(this as any).rowConfig]
    }
    d
    private weblinksTable: MdsLax<InstanceType<typeof StaticTable>>;
    private weblinksStore: MdsLax<InstanceType<typeof EntityStore<WebfileLink>>>;

    open(file: VtFile) {
        this.file = file;
        this.inputFilename.setValue(file.filename, true);
        this.inputFileCategory.setValue(file.ref_file_category.description, true);
        this.show("dlg", this.translate("General_Heading_WeblinkfOf") + ": " + file.gDisp_1);
        this.setupTable();
        this.loadWeblinksOfFile();

        this.addButton("new_dropdown", this.translate("General_New"), lang.hitch(this, this._onClickNewButton), null, "newBtn dropdownBtn", null, false, "primary", true, 40);
    }

    private setupTable() {
        this.weblinksTable = new StaticTable();
        this.weblinksTable.addLayout(this.tableLayout);
        this.weblinksTable.setupFromStore(this.weblinksStore);
        this.weblinksTable.addCustomRowActionButton("choose", lang.hitch(this, this._onClickSelectWeblink), "fas fa-folder-open", null, null, this.translate("General_Label_Open"));
        this.weblinksTable.setRowClick(lang.hitch(this, this._onClickTableRow));
        this.weblinksTable.setCyAttribute("FileWeblinksDlgWeblinksTable");

        this.weblinksTable.placeAt(this.tableContainer);
    }

    private _onClickTableRow(row: StaticTable.StaticTableRow<WebfileLink>) {
        let entity = row.rowGroup.entity;

        this._onSelectEntity(entity);
    }

    private _onClickSelectWeblink(rowGroup: StaticTable.StaticTableRowGroup<WebfileLink>) {
        let entity = rowGroup.entity;

        this._onSelectEntity(entity);
    }

    private _onSelectEntity(entity: WebfileLink) {
        this.emit("selected", entity);
        this.close();
    }

    private _storeHasPlacement(placement: WebPlacement) {
        let completeList = this.weblinksStore.getCurrentCompleteList();

        for (let entry of completeList) {
            if (entry.ref_web_placement.ID === placement.ID) return true;
        }

        return false;
    }

    private _onClickNewButton(e) {
        let filteredList = this.webPlacements.filter((value) => {
            return !this._storeHasPlacement(value);
        });

        let menu = new FloatingMenu();

        for (let placement of filteredList) {
            menu.addEntry({
                callback: lang.hitch(this, this._onClickMenuEntry, placement),
                label: placement.description,
            });
        }

        menu.open(e, null, this.translate("General_Heading_WebPlacementMenu"));
    }

    private _onClickMenuEntry(placement: WebPlacement) {
        let newWebfileLink = {
            ID: "" + Math.random() * 100000000,
                isNewWeblink: true,
                $Displayname: "",
                Classname: "",
                ClassPrintname: "",
                description: this.file.filename,
                EL_ht_webfile_link_category_webfile_link: [],
                ref_web_placement: placement,
                ref_main_ht_webfile_link_catergory: null,
                ref_vt_files: this.file
        }

        this._onSelectEntity(newWebfileLink);
    }

    private loadWeblinksOfFile() {
        this.StandbyStart();

        let requestData = { entityId: this.file.ID, className: this.file.Classname };

        this.RequestManager.callfunction("Webtool_API__Weblinks_GetWeblinksOfFile", requestData, lang.hitch(this, this._onLoadWeblinksOfFileResponse), lang.hitch(this, this._onLoadWeblinksOfFileError));
    }

    private _onLoadWeblinksOfFileResponse(response: { weblinks: Array<WebfileLink>, webPlacements: Array<WebPlacement> }) {
        this.StandbyStop();
        console.log(response);
        this.weblinksStore.setup(response.weblinks);
        this.webPlacements = response.webPlacements;
    }

    private _onLoadWeblinksOfFileError(error) {
        this.StandbyStop();
        console.error(error);
    }



    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.weblinksStore = new EntityStore();
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(FileWeblinksDlg);